module.exports = __webpack_public_path__ + "static/media/star-light.176127df.svg";